import 'lazysizes';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import './Presentation/Organism/AltTextWidget/AltTextWidget';

Alpine.plugin(focus);
Alpine.plugin(collapse);

// We use this to enable the AlpineJS debugger in the browser.
if (document.documentElement.dataset.debug != undefined) {
    window.Alpine = Alpine;
}

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== "function") {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch(e => setTimeout(() => {
                throw e;
            }));
    };
}

Alpine.start();

// This loads the fastspring checkout by query string, so the page can be called with e.g. ?buy=basic-monthly
if (document.querySelector('#pricingTable')) {
    document.addEventListener('DOMContentLoaded', function () {
        const url = new URL(window.location.href);

        if (url.searchParams.get('buy')?.length === 0) {
            return;
        }

        const typeToQueryString = url.searchParams.get('buy');
        if (typeToQueryString === null) {
            return;
        }

        const product = document.querySelector(`[data-fsc-item-path-value\$="${typeToQueryString}"]`).attributes['data-fsc-item-path-value']?.value;
        if (product === null) {
            return;
        }

        fastspring.builder.add(product);
        fastspring.builder.checkout();
    });
}
